/**
 * Executor access gates (s127 fix — post-death tier lockout).
 *
 * Two-gate design: gate 1 = accepted access (PRE-death; `sharing_tier` chooses the progress-only
 * vs read-access VIEWING experience). Gate 2 = a VERIFIED death = the FULL estate unlock.
 *
 * A pre-death "Progress only" (tier 1) setting is a VIEWING preference the planner made while
 * alive — it must NOT survive verification. Letting it gate the post-death estate strands the
 * settlement: the executor can't run the task list, letters, or documents for an estate they are
 * legally responsible for. So the full post-death estate unlocks on `deathVerified` ALONE,
 * regardless of `sharing_tier`; and any Primary executor may report the death.
 */
export function canAccessFullEstate(deathVerified: boolean): boolean {
  return deathVerified;
}

/** A Primary executor can report the death when one hasn't been reported yet. Deliberately NOT
 *  tier-gated (s127): "Progress only" is a pre-death viewing choice, not a licence to strand the
 *  estate by blocking the one action that unlocks settlement. */
export function primaryCanReportDeath(isPrimary: boolean, hasDeathEvent: boolean): boolean {
  return isPrimary && !hasDeathEvent;
}
